// import React from "react";

// const Digitalfactorybanner = () => {
//   const bannerStyles = {
//     // marginTop:"60px",
//     width: "100%",
//     height: "90vh", 
//     backgroundImage: "url('/image/ai-robot-interacting-with-futuristic-data-interface_23-2152005489.avif')",  
//     backgroundSize: "cover",
//     backgroundPosition: "center center",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     color: "white",
//     position: "relative",
//     overflow: "hidden",
//   };

//   const contentStyles = {
//     maxWidth: "90%",
//     padding: "0 20px",  
//   };

//   const headingStyles = {
//     fontSize: "4rem",  
//     margin: 0,
//     lineHeight: 1.2,
//     fontWeight: "bold",
//   };

//   const paragraphStyles = {
//     fontSize: "1.5rem",  
//     marginTop: "1rem",
//   };

  
//   const mediaQueryStyles = {
//     "@media (max-width: 1200px)": {
//       heading: { fontSize: "3.5rem" },
//       paragraph: { fontSize: "1.3rem" },
//     },
//     "@media (max-width: 768px)": {
//       heading: { fontSize: "2.5rem" },
//       paragraph: { fontSize: "1.2rem" },
//     },
//     "@media (max-width: 480px)": {
//       heading: { fontSize: "2rem" },
//       paragraph: { fontSize: "1rem" },
//     },
//   };

//   return (
//     <div style={bannerStyles}>
//       <div style={contentStyles}>
       
        
//       </div>
//     </div>
//   );
// };

// export default Digitalfactorybanner;



import React from "react";

const Digitalfactorybanner = () => {
  const bannerStyles = {
    width: "100%",
    height: "100vh",
    backgroundImage:
      "url('/image/ai-robot-interacting-with-futuristic-data-interface_23-2152005489.avif')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
  };

  const contentStyles = {
    maxWidth: "90%",
    padding: "0 20px",
    position: "relative",
    zIndex: 2, // content above overlay
  };

  const headingStyles = {
    fontSize: "4rem",
    margin: 0,
    lineHeight: 1.2,
    fontWeight: "bold",
    color: "#000",
  };

  const paragraphStyles = {
    fontSize: "1.5rem",
    marginTop: "1rem",
    color: "#025261",
    fontWeight: "500",
  };

  return (
    <>
      <style>
        {`
          /* Overlay */
          .digital-banner::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.55);
            z-index: 1;
          }

          /* Responsive text */
          @media (max-width: 1200px) {
            .digital-heading {
              font-size: 3.5rem;
            }
            .digital-text {
              font-size: 1.3rem;
            }
          }

          @media (max-width: 768px) {
            .digital-heading {
              font-size: 2.5rem;
            }
            .digital-text {
              font-size: 1.2rem;
            }
          }

          @media (max-width: 480px) {
            .digital-heading {
              font-size: 2rem;
            }
            .digital-text {
              font-size: 1rem;
            }
          }
        `}
      </style>

      <div style={bannerStyles} className="digital-banner">
        <div style={contentStyles}>
          {/* Optional Content (aap baad me add kar sakte ho) */}
          {/* 
          <h1 className="digital-heading" style={headingStyles}>
            Digital Factory
          </h1>
          <p className="digital-text" style={paragraphStyles}>
            Smart Manufacturing with AI & Automation
          </p> 
          */}
        </div>
      </div>
    </>
  );
};

export default Digitalfactorybanner;




